import React from "react";
import Papa from "papaparse"; // Import Papa Parse for CSV handling
import "./App.css";

function Documentation() {
  // List of CSV files in the archive
  const csvFiles = [
    { name: "nov_old_data.csv", path: "/nov_old_data.csv" },
  ];

  // Function to download a CSV file
  const downloadCSV = async (filePath, fileName) => {
    try {
      const response = await fetch(filePath);
      const text = await response.text();
      const blob = new Blob([text], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      alert("Failed to download the CSV file.");
    }
  };

  // Function to copy CSV text to the clipboard
  const copyCSVText = async (filePath) => {
    try {
      const response = await fetch(filePath);
      const text = await response.text();
      await navigator.clipboard.writeText(text);
      alert("CSV text copied to clipboard!");
    } catch (error) {
      alert("Failed to copy CSV text.");
    }
  };

  return (
    <div className="doc-container">
      {/* Documentation Section */}
      <h2> </h2>
      <div className="doc-content">
        <p>
          Data and Web, by @xostrngr
        </p>
        <p>
          To filter through data, use the built-in column filters, AI tools, separate scripts, and third-party websites to further analyze traders.
        </p>
        <p>
          Most data is self-explanatory. If you need help, DM me.
        </p>
        <p>
          Below is an archive of previous trading data compiled into csv files.
        </p>

      </div>

      {/* Archive Section */}
      <div className="archive-container">
        <h2> </h2>
        {csvFiles.map((file, index) => (
          <div key={index} className="archive-item">
            <span className="csv-file-name">{file.name}</span>
            <button
              className="custom-button"
              onClick={() => downloadCSV(file.path, file.name)}
            >
              Download File
            </button>
            <button
              className="custom-button"
              onClick={() => copyCSVText(file.path)}
            >
              Copy File Text
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Documentation;